import { Stack } from '../types/shell';

export const getStack = (): Stack | undefined => {
  const stack = (window as any).Shell?.v1.app.getAuthStack();
  const devStacks = [Stack.dev, Stack.pie, Stack.stage];

  return devStacks.includes(stack) ? Stack.stage : Stack.prod;
};
